const commonMethods = {
  getFailedResponseObject(responseObj, message) {
    responseObj.isValid = false
    responseObj.message = message
    return responseObj
  },
}

export { commonMethods }
